export const GET_LOADINDEXS_STATED = "GET_LOADINDEXS_STATED";
export const GET_LOADINDEXS = "GET_LOADINDEXS";
export const GET_LOADINDEXS_ENDED = "GET_LOADINDEXS_ENDED";
export const ADD_LOADINDEX_STATED = "ADD_LOADINDEX_STARTED";
export const ADD_LOADINDEX = "ADD_LOADINDEX";
export const ADD_LOADINDEX_ENDED = "ADD_LOADINDEX_ENDED";
export const EDIT_LOADINDEX_STATED = "EDIT_LOADINDEX_STATED";
export const EDIT_LOADINDEX = "EDIT_LOADINDEX";
export const EDIT_LOADINDEX_ENDED = "EDIT_LOADINDEX_ENDED";
export const GET_LOADINDEX = "GET_LOADINDEX";
export const GET_LOADINDEX_STATED = "GET_LOADINDEX_STATED";
export const GET_LOADINDEX_ENDED = "GET_LOADINDEX_ENDED";
export const RESET_LOADINDEX = "RESET_LOADINDEX";
export const ERROR_LOADINDEX = "ERROR_LOADINDEX";
export const GET_ALL_LOADINDEXS_STATED = "GET_ALL_LOADINDEXS_STATED";
export const GET_ALL_LOADINDEXS = "GET_ALL_LOADINDEXS";
export const GET_ALL_LOADINDEXS_ENDED = "GET_ALL_LOADINDEXS_ENDED";
